import React from 'react';
import { IconButton } from '@material-ui/core';
import { Assessment } from '@material-ui/icons';
import { Link } from 'react-router-dom';

const LinkComponent = ({ pathname, search, referrer }: { pathname: string; search?: string; referrer?: string }) => (
    <Link
        to={{
            search,
            pathname,
            state: { referrer },
        }}
    >
        <IconButton
            color='primary'
        >
            <Assessment />
        </IconButton>
    </Link>
);

export default LinkComponent;
